export default class Steel {
  barsCrossTensionFailure = false
  barsPreventTensionBreakout = false
  shearXNumber4Bars = false
  shearXStirrups = false
  shearXNoBreakout = false
  shearYNumber4Bars = false
  shearYStirrups = false
  shearYNoBreakout = false
  dirty = false

  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onUpdate(detail) {
    Object.assign(this, detail)
    this.publishUpdate()
  }

  publishUpdate() {
    this.dirty = true
    let event = new CustomEvent('anchor-model-update', { detail: this });
    document.dispatchEvent(event)
    // update our button
    event = new CustomEvent('steel-model-update', { detail: {boltAndNut: this} });
    document.dispatchEvent(event)
  }
}